export interface ModalOptions {
    showAcceptBtn?: boolean;
    showCancelBtn?: boolean;
    title?: string;
    message?: string;
    disableAutoClose?: boolean;
    maxWidth?: string; // standard, big, small
}

export class ModalOptionsHelper {
    static default() {
        return {
            showAcceptBtn: false,
            showCancelBtn: false,
            title: null,
            message: null,
            disableAutoClose: false,
            maxWidth: 'standard',
        };
    }

    static create(props: ModalOptions = null) {
        const d = ModalOptionsHelper.default();
        return {
            ...d,
            ...props,
        };
    }
}

export interface ModalSubjectData {
    modalId: string;
    options?: ModalOptions;
    data?: any;
    accepted: boolean;
    cancelled: boolean;
}

export class ModalSujectDataHelper {
    static default() {
        return {
            modalId: null,
            options: ModalOptionsHelper.default(),
            data: null,
            accepted: null,
            cancelled: null,
        };
    }

    static create(props: ModalSubjectData = null) {
        const d = ModalSujectDataHelper.default();
        return {
            ...d,
            ...props,
        };
    }
}
